import React, { useEffect, useState } from "react";
import { formatFileName } from "../util/functions";
import { fileStore } from "../zustand/index";
import { isArray, isEmpty } from "underscore";
import fileIcon from "../assets/file.svg";
import { filesize } from "filesize";
import { IoIosClose } from "react-icons/io";


function ImagePreview({ activeKey }) {
  const {
    files: filesRepo,
    getFileType,
    getFiles,
    deleteFile,
    previewFiles,
    addPreviewFiles,
    getPreviewFiles,
  } = fileStore();

  const [files, setFiles] = useState([]);
  const [activeFiles, setActiveFiles] = useState([]);

  //////////////////////////////////////////////////////////////

  const handleUploadFile = async () => {
    const fileObjs = await Promise.all(
      Array.from(files).map(async (file) => {
        // const url = await createPreviewUrl(file);
        const fileType = await getFileType(file);
        return { file: file, ...file, ...fileType };
      })
    );
    addPreviewFiles(activeKey, fileObjs);
  };

  useEffect(() => {
    handleUploadFile();
  }, [files]);

  useEffect(() => {
    const data = getPreviewFiles(activeKey);
    setActiveFiles(data);
  }, [previewFiles, activeKey]);

  //////////////////////////////////////////////////////////////
  useEffect(() => {
    if (isEmpty(filesRepo)) {
      return;
    }
    const init = async () => {
      const data = getFiles(activeKey);
      setFiles(data);
    };
    init();
  }, [filesRepo, activeKey]);

  //////////////////////////////////////////////////////////////

  return (
    <div className="carousel carousel-center bg-neutral rounded-box max-w-md space-x-4 py-4">
      {activeFiles &&
        !isEmpty(activeFiles) &&
        isArray(activeFiles) &&
        activeFiles.map((file, index) => (
          <div key={index} className="carousel-item w-36 h-20 rounded relative">
            <div className="top-0 right-2 z-10">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  deleteFile(activeKey, index);
                }}
                className="preview-btn"
              >
                <IoIosClose className="" size={16} />
              </button>
            </div>
            {file.type === 'image' && (
              <img src={file.link} alt={file.name} />
            )}
            {file.type === 'video' && <video src={file.link} controls />}
            {file.type === 'document' && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1rem' }} className="flex items-center justify-center card">
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1rem', padding: '0.5rem' }} className="card-body flex-row flex items-center gap-2 shadow-sm rounded-lg bg-slate-50 p-2">
                  <img src={fileIcon} alt="" className="fileIcon h-8 w-8" />
                  <div className="flex flex-col gap-1">
                    <p className="text-wrap">
                      {formatFileName(file.file.name)}
                    </p>
                    <span style={{ fontSize: '0.8rem', color: '#777' }} className="text-xs text-gray-500">
                      {filesize(file.file.size)}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
    </div>
  );
}

export default ImagePreview;